<template>
  <div class="card-item-container flex-hl-vc">
    <a-checkbox v-if="checkedAble" @change="change(coupon)" :checked="coupon.checked" :disabled="coupon.disabled" class="card-item-checkbox"></a-checkbox>
    <div :class="['card-item-main', `bg-${cardTypeClassMap[coupon.type]}`, {'card-item-disabled': coupon.disabled}]">
      <div class="card-header">
        <div class="title" :class="{disabled: coupon.status !== 1}" :title="coupon.name"><span>- {{ coupon.name }} -</span></div>
      </div>
      <div class="card-body">
        <div class="card-m clearfix">
          <div class="tail">
            <div :class="['price', {reduc: coupon.preferentialType === 0, discount: coupon.preferentialType === 1}]">
              <small>{{ coupon.preferentialType === 0 ? '￥' : '折' }}</small>
              <span class="tag" :style="{'font-size': getFontSize(coupon) + 'px'}">{{ coupon.preferentialType === 0 ? coupon.maxAmount : coupon.preferentialValue*10 }}</span>
            </div>
            <div class="more" @click.stop="showDetail">卡券详情</div>
          </div>
          <div class="info">
            <div class="info-m">
              <!-- <div class="desc">满{{ coupon.couponQuata }}可用</div> -->
              <div class="date">有效期至{{ coupon.endDate | dateFilter('YYYY-MM-DD') }}</div>
              <div class="status" :class="{'disabled': coupon.status !== 1}">
                <span v-if="checkedAble">{{ coupon.status === 1 ? '可使用' : '不可用' }}</span>
                <span v-else>{{ coupon.status | couponStatus }}</span>
              </div>
            </div>
            <!-- <div class="bord"><div class="brd"></div></div> -->
            <!-- <l8-icon v-show="checked" class="l8-icon checked-icon" type="icon-CombinedShape"/> -->
          </div>
        </div>
      </div>
      <a-modal
        title="卡券详情"
        :visible="visible"
        destroyOnClose
        :width="640"
        @cancel="visible = false"
      >
        <template slot="footer">
          <a-button type="primary" @click="visible = false">
            确认
          </a-button>
        </template>
        <div class="mod-card-detail">
          <table>
            <colgroup>
              <col>
              <col>
              <col>
              <col>
              <col>
            </colgroup>
            <tbody>
              <tr>
                <td colspan="2">卡券号</td>
                <td colspan="1">卡券类型</td>
                <td colspan="1">优惠类型</td>
                <td colspan="1">优惠值</td>
                <td colspan="1">最大优惠金额</td>
              </tr>
              <tr>
                <td colspan="2">{{ coupon.couponCode }}</td>
                <td colspan="1">{{ coupon.type | cardType }}</td>
                <td colspan="1">{{ coupon.preferentialType | couponType }}</td>
                <td colspan="1" v-if="coupon.preferentialType === 0">{{ `${coupon.preferentialValue}元` }}</td>
                <td colspan="1" v-else>{{ `${coupon.preferentialValue*10}折` }}</td>
                <td colspan="1">{{ coupon.maxAmount }}元</td>
              </tr>
              <tr>
                <td colspan="3">优惠券有效期</td>
                <td colspan="2">领取时间</td>
                <td colspan="1">转赠次数</td>
              </tr>
              <tr>
                <td colspan="3">{{ `${coupon.startDate} - ${coupon.endDate}` }}</td>
                <td colspan="2">{{ coupon.receiveTime }}</td>
                <td colspan="1">{{ coupon.giveNum === 0 ? '不可转赠' : coupon.giveNum }}</td>
              </tr>
              <tr>
                <td colspan="6">备注</td>
              </tr>
              <tr>
                <td colspan="6">{{ coupon.remark || '-'  }}</td>
              </tr>
            </tbody>
          </table>
          <div class="tip" v-if="coupon.couponRuleDetails">
            <h6>用券须知<span v-if="coupon.couponRuleDetails.length > 1">（满足以下任意条件即可使用）</span>：</h6>
            <div v-for="(rItem, rIndex) in coupon.couponRuleDetails" :key="rIndex">
              <span v-if="coupon.couponRuleDetails.length > 1">{{ rIndex + 1 }}.</span>
              <span style="white-space: pre-wrap;" v-html="rItem.desc"></span>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>

</template>

<script>
import '../../pages/usercoupon/config.js'
import { couponStatus, cardType, couponType, source } from '@/filters/coupon'
import { cardTypeClassMap } from '@/dicts/coupon'
import { dateFilter } from '@/filters/util'
export default {
  name: 'CouponTicket',
  props: {
    data: Object,
    checked: {
      type: Boolean,
      default: false
    },
    checkedAble: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      visible: false,
      currCoupon: {},
      cardTypeClassMap
    }
  },
  computed: {
    coupon () {
      return this.data
    },
    getAllowDetail () {
      return function (value, type) {
        return value ? value.map(item => { return item[type] }).join(',') : ''
      }
    },
    couponTypeClassName () {
      return `card-type-${this.coupon.couponType}`
    }
    // backgroundImage () {
    //   const image = couponBgMaps.find(item => item.type === this.coupon.couponType).image
    //   return `url(${image})`
    // }
  },
  methods: {
    showDetail () {
      this.visible = true
    },
    change (coupon) {
      this.$emit('change', coupon)
    },
    getFontSize (coupon) {
      const defaultFontSize = 36
      const baseMaxAmount = String(coupon?.maxAmount)?.length - 2
      if (coupon.preferentialType === 1 || baseMaxAmount <= 0) {
        return defaultFontSize
      } else {
        return defaultFontSize - baseMaxAmount * 8
      }
    }
  },
  filters: {
    dateFilter,
    couponStatus,
    cardType,
    couponType,
    source
  }
}
</script>

<style lang="less">
  .card-item-container {
    flex: 0 1 auto;
    width: 25%;
    min-width: 300px;
    margin-bottom: 10px;

    .card-item-checkbox {
      padding: 0 15px;
    }
    .card-item-main {
      width: 240px;
      height: 120px;
      background: url("./img/card-coupon-bg.png") no-repeat;
      background-size: cover;
      color: #fff;
      position: relative;
      &.bg-flight {
        background-image: url("./img/card-coupon-bg-flight.png");
      }
      &.bg-ancillary {
        background-image: url("./img/card-coupon-bg-ancillary.png");
      }
      &.bg-combo {
        background-image: url("./img/card-coupon-bg-combo.png");
      }
      &.card-item-disabled {
        filter: grayscale(100%);
        filter: gray;
      }

      .more {
        cursor: pointer;
        text-align: center;
      }

      .card-header {
        .title {
          color: #c1a04a;
          display: block;
          margin-left: 12px;
          text-align: left;
          line-height: 18px;
          font-size: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 130px;
          &.disabled {
            color: #666;
          }
        }
      }

      .card-m {
        width: 100%;
        box-sizing: border-box;
        clear: both;
        position: relative;

        .checked-icon {
          color: #4acd0b;
          position: absolute;
          font-size: 36px;
          right: -24px;
          bottom: -6px;
          z-index: 10;

          &:after {
            content: '';
            position: absolute;
            width: 66%;
            height: 66%;
            top: 17%;
            left: 17%;
            display: block;
            background: #fff;
            z-index: -1;
          }
        }
      }

      .info {
        width: 62%;
        padding-top: 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        float: left;
        text-align: center;
        line-height: 2;
      }

      .info-m {
        position: relative;
        z-index: 2;
      }

      .tail {
        width: 38%;
        float: right;

        .price {
          padding: 12px 0 5px 20px;
          position: relative;
          text-align: center;
          height: 60px;
          box-sizing: content-box;
          // padding-left: 30px;

          small {
            font-size: 16px;
            // margin-right: -2px;
            position: absolute;
            bottom: 13px;
            line-height: 1;
          }

          .tag {
            // font-size: 61px;
            font-size: 40px;
            font-family: impact, sans-serif;
            position: absolute;
            bottom: 13px;
            line-height: 1;
            left: 35px;
          }
        }

        .reduc {
          small {
            left: 19px;
          }
        }

        .discount {
          padding-right: 12px;
          padding: 12px 0 5px 5px;

          small {
            right: 14px;
          }

          .tag {
            font-size: 40px;
          }
        }
      }

      .desc {
        font-size: 14px;
        font-weight: bold;
      }

      .date {
        font-size: 12px;
      }

      .status {
        margin: 2px auto;
        width: 70px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 5px;
        // background: linear-gradient(to right, #fa2d36, #da101a);
        background-color: rgba(0, 0, 0, .25);

        &.disabled {
          background: #666;
        }
      }

      .more {
        font-size: 12px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .mod-card-detail {
    table {
      width: 100%;
      table-layout: fixed;
    }

    td {
      padding: 6px;
      border: 1px solid #ddd;
      font-size: 12px;
      vertical-align: middle;
    }

    tr:nth-child(2n+1) {
      td {
        background-color: #f5f5f5;
      }
    }

    .tip {
      margin-top: 12px;

      h6 {
        line-height: 28px;
        font-weight: 700;
      }

      p {
        line-height: 20px;
        font-size: 12px;
        color: #888;
      }
    }
  }

</style>
